import { Stack } from "@similarweb/ui-components/foundations";

import { COMING_SOON_PROVIDERS } from "../../constants/contact-providers";
import { AvailableProviderCard } from "../AvailableProviderCard/AvailableProviderCard";
import { ProvidersPanel } from "../ProvidersPanel/ProvidersPanel";

export const AvailableProvidersPanel = () => {
    return (
        <ProvidersPanel
            titleKey="si.pages.contacts_waterfall.available_providers.title"
            subtitleKey="si.pages.contacts_waterfall.available_providers.subtitle"
            flex="0 0 404px"
            minWidth="404px"
            data-automation="contacts-waterfall-available-providers"
        >
            <Stack gap="12px">
                {COMING_SOON_PROVIDERS.map((provider) => (
                    <AvailableProviderCard
                        key={provider.domain}
                        provider={provider}
                    />
                ))}
            </Stack>
        </ProvidersPanel>
    );
};
